import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

// import usePrivateLink from "../config/usePrivateLink";
// import { useNavigate, useLocation } from "react-router-dom";

// const StaffHeader = ({ data }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const tabs = [
//     { id: "CreateStaff", title: "Add Staff", icon: "fa-solid fa-pen-to-square", path: "/staff/add" },
//     { id: "staffList", title: "Staff List", icon: "fa-solid fa-list", path: "/staffs" },
//     { id: "workingschedule", title: "Working Schedule", icon: "fa-solid fa-file-circle-plus", path: "/teacher/working/schedule" },
//     { id: "scheduleCreate", title: "Schedule Create", icon: "fa-solid fa-eye", path: "/staff/schedule/create" },
//     { id: "experienceCertificate", title: "Experience Certificate", icon: "fa-solid fa-eye", path: "/experience/certificate" },
//     { id: "experienceCertificate", title: "Salary Slip", icon: "fa-solid fa-eye", path: "/salary/slip" },
//    ,
//   ];

//   return (
//     <div className="">

//       {/* ✅ Sidebar Menu */}
//       <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
//         <h5 className="text-primary text-center p-2">{data}</h5>
//         {tabs.map((tab) => {
//           const isActive = location.pathname === tab.path;

//           return (
//             <button
//               key={tab.id}
//               className={`list-group-item list-group-item-action d-flex align-items-center ${
//                 isActive ? "active" : ""
//               }`}
//               onClick={() => navigate(tab.path)}
//             >
//               <i className={`${tab.icon} me-2`} />
//               {tab.title}
//             </button>
//           );
//         })}
//       </div>

//       {/* ✅ Page Content */}
//     </div>
//   );
// };

// export default StaffHeader;


const StaffHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
    {
      id: "staffList",
      title: "Staff List",
      icon: "ri-team-line",
      path: "/staffs",
    },
    {
      id: "staff_today",
      title: "Attendance Today",
      icon: "ri-group-line",
      path: "/staff/attendance/list",
    },

    {
      id: "staff_monthly",
      title: "Attendance Monthly",
      icon: "ri-calendar-2-line",
      path: "/staff/attendance/list/monthly",
    },

    {
      id: "workingschedule",
      title: "Working Schedule",
      icon: "ri-calendar-check-line",
      path: "/teacher/working/schedule",
    },

    // {
    //   id: "experienceCertificate",
    //   title: "Experience Certificate",
    //   icon: "ri-file-list-3-line",
    //   path: "/experience/certificate",
    // },
    // // alternative if file-certificate not available → "fa-solid fa-file-lines"

    // {
    //   id: "salarySlip",
    //   title: "Salary Slip",
    //   icon: "ri-file-paper-2-line",
    //   path: "/salary/slip",
    // },
    // {
    //   id: "CC",
    //   title: "Character Certificate",
    //   icon: "ri-file-paper-2-line",
    //   path: "/character/certificate",
    // },

    ,
  ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <div className="">
      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">
            You don't have permission to access any tabs.
          </div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${
                isActive ? "bg-label-primary" : ""
              } ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default StaffHeader;
